import { useTranslation } from 'react-i18next'

import { Checkbox } from '@enechain/ecloud-designsystem'

type Props = {
  includeExpired: boolean
  onChange: (v: boolean) => void
  /** useExpiryFilter().expiredCount (= 終了した行の件数。 トグルの状態に関わらず数える)。 */
  expiredCount: number
  /**
   * タブごとの対象名 (例: 事業者 / BG / 計画提出者 / 需要調達計画 / 発電販売計画 /
   * 需要抑制計画)。 design/admin/occto.html の STATUS_NOUN と 1:1 対応で、
   * label に差し込む (「終了した事業者も表示」を BG タブに出さないため)。
   */
  subject: string
}

/**
 * 失効表示トグル (occto-master-valid-period-6tabs 設計書 §7 AC-09)。
 *
 * 終了した行の件数はラベルの末尾にかっこで出す (「終了した BG も表示 (2)」、
 * 2026-10-20 デザイナー指示: 脇の「終了した BG 2件を非表示中」は長い)。 件数は
 * 隠している数でなく終了した行の数なので、 押してもラベルは変わらない。
 * 全件失効でトグル OFF の時は、 表の空状態が「終了した〜 N 件を非表示中」を出す
 * (useMasterCrudTab の emptyLabel)。
 */
export const ExpiredFilterToggle = ({
  includeExpired,
  onChange,
  expiredCount,
  subject,
}: Props): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <Checkbox
      checked={includeExpired}
      onCheckedChange={(details: { checked: boolean | 'indeterminate' }) => {
        onChange(details.checked === true)
      }}
    >
      {expiredCount > 0
        ? t('page:adminOcctoMaster.common.includeExpiredWithCount', {
            subject,
            count: expiredCount,
          })
        : t('page:adminOcctoMaster.common.includeExpired', { subject })}
    </Checkbox>
  )
}
